// exitEntryApi.js

import api from './api';

export const fetchExitEntryRequests = async (params = {}) => {
  const response = await api.get('/exit-entry-requests', { params });
  return response.data;
};
export const fetchExitEntryPrRequests = async () => {
  const response = await api.get('/exit-entry-requests/pr');
  return response.data;
};


export const createExitEntryRequest = async (formValues) => {
  const formData = new FormData();
  formData.append('validity_from_date', formValues.validity_from_date);
  formData.append('validity_to_date', formValues.validity_to_date);
  formData.append('visa_type', formValues.visa_type);

  if (formValues.country !== undefined) {
    formData.append('country', formValues.country);
  }
  if (formValues.phone_number !== undefined) {
    formData.append('phone_number', formValues.phone_number);
  }
  if (formValues.location_in_country !== undefined) {
    formData.append('location_in_country', formValues.location_in_country);
  }

  if (formValues.period_in_days) {
    formData.append('period_in_days', formValues.period_in_days);
  }
  if (formValues.reason) {
    formData.append('reason', formValues.reason);
  }
  if (formValues.document) {
    formData.append('document', formValues.document);
  }

  const response = await api.post('/exit-entry-requests', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const updateExitEntryRequest = async (id, formValues) => {
  const formData = new FormData();
  formData.append('validity_from_date', formValues.validity_from_date);
  formData.append('validity_to_date', formValues.validity_to_date);
  formData.append('visa_type', formValues.visa_type);

  if (formValues.country !== undefined) {
    formData.append('country', formValues.country);
  }
  if (formValues.phone_number !== undefined) {
    formData.append('phone_number', formValues.phone_number);
  }
  if (formValues.location_in_country !== undefined) {
    formData.append('location_in_country', formValues.location_in_country);
  }

  if (formValues.period_in_days) {
    formData.append('period_in_days', formValues.period_in_days);
  }
  if (formValues.reason) {
    formData.append('reason', formValues.reason);
  }
  if (formValues.document) {
    formData.append('document', formValues.document);
  }

  const response = await api.put(`/exit-entry-requests/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const updateRequestStatus = async (id, { status, attachment }) => {
  const formData = new FormData();
  formData.append('status', status);
  console.log('status', status);
  console.log('Form data', formData );
  if (attachment) {
    formData.append('attachment', attachment);
  }

  // Remove the headers object entirely or at least the Content-Type header:
  const response = await api.post(`/exit-entry-requests/${id}/status`, formData);
  return response.data;
};


export const cancelExitEntryRequest = async (id) => {
  const response = await api.patch(`/exit-entry-requests/${id}/cancel`);
  return response.data;
};

export const fetchExitEntryAssignedBreakdown = async (queue = 'pending') => {
  const response = await api.get('/exit-entry-requests/assigned-breakdown', {
    params: { queue },
  });
  return response.data;
};
